import { Link, useNavigate } from "react-router-dom";
import { ShoppingBag, User, Heart, MagnifyingGlass, List, X } from "@phosphor-icons/react";
import { useCart } from "../context/CartContext";
import { useAuth } from "../context/AuthContext";
import { useState } from "react";

const NAV = [
  { label: "Reconnect", to: "/reconnect" },
  { label: "Lingerie", to: "/shop?category=bras" },
  { label: "Sets", to: "/shop?category=sets" },
  { label: "Nightwear", to: "/shop?category=nightwear" },
  { label: "Loungewear", to: "/shop?category=loungewear" },
  { label: "Lookbook", to: "/lookbook" },
];

export default function Header() {
  const { setOpen, count } = useCart();
  const { user } = useAuth();
  const nav = useNavigate();
  const [mobile, setMobile] = useState(false);

  return (
    <>
      {/* Announcement bar */}
      <div className="bg-[#1A1A1A] text-[#FAF8F5] overline text-center py-2.5" data-testid="announcement-bar">
        Not another lingerie box · A way back to each other · Free shipping over ₹5,000
      </div>

      <header className="sticky top-0 z-50 bg-[#FAF8F5]/80 backdrop-blur-xl border-b border-[#E6DED5]/50" data-testid="site-header">
        <div className="max-w-[1600px] mx-auto px-6 lg:px-12 py-5 flex items-center justify-between gap-8">
          <button className="lg:hidden" onClick={() => setMobile(true)} data-testid="mobile-menu-btn" aria-label="Menu">
            <List size={22} weight="light" />
          </button>

          <Link to="/" className="font-serif text-2xl lg:text-3xl tracking-tight text-[#1A1A1A] flex-1 lg:flex-none text-center lg:text-left leading-none" data-testid="brand-logo">
            <div>Iamravishing<span className="text-[#4A1525]">.</span></div>
            <div className="hidden lg:block overline text-[8px] text-[#5C5C5C] mt-1 tracking-[0.3em]">Reconnect · Intimate apparel</div>
          </Link>

          <nav className="hidden lg:flex items-center gap-8 flex-1 justify-center">
            {NAV.map(n => (
              <Link key={n.to} to={n.to} className="overline text-[#1A1A1A] hover:text-[#4A1525] transition-colors" data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g,'-')}`}>
                {n.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-4 lg:gap-5">
            <button className="hidden md:block" data-testid="search-btn" aria-label="Search">
              <MagnifyingGlass size={20} weight="light" />
            </button>
            <button onClick={() => nav(user ? "/account" : "/login")} data-testid="account-btn" aria-label="Account">
              <User size={20} weight="light" />
            </button>
            <button onClick={() => nav(user ? "/wishlist" : "/login")} data-testid="wishlist-btn" aria-label="Wishlist">
              <Heart size={20} weight="light" />
            </button>
            <button onClick={() => setOpen(true)} className="relative" data-testid="cart-btn" aria-label="Cart">
              <ShoppingBag size={20} weight="light" />
              {count > 0 && (
                <span className="absolute -top-2 -right-2 bg-[#4A1525] text-[#FAF8F5] text-[10px] w-4 h-4 flex items-center justify-center rounded-full" data-testid="cart-count">
                  {count}
                </span>
              )}
            </button>
          </div>
        </div>
      </header>

      {/* Mobile drawer */}
      {mobile && (
        <div className="fixed inset-0 z-[60] bg-[#FAF8F5] lg:hidden fade-up" data-testid="mobile-menu">
          <div className="flex justify-between items-center p-6 border-b border-[#E6DED5]">
            <span className="font-serif text-2xl">Iamravishing<span className="text-[#4A1525]">.</span></span>
            <button onClick={() => setMobile(false)} data-testid="close-mobile-menu"><X size={22} weight="light" /></button>
          </div>
          <nav className="flex flex-col p-6 gap-6">
            {NAV.map(n => (
              <Link key={n.to} to={n.to} onClick={() => setMobile(false)} className="font-serif text-3xl text-[#1A1A1A]" data-testid={`mnav-${n.label.toLowerCase().replace(/\s+/g,'-')}`}>
                {n.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </>
  );
}
